import { c as _c } from "react/compiler-runtime";
import { displayPercentageDiscount } from "@website/accommodation-ui/helpers/calculatePercentageDiscount";
import { useCompatRouter } from "@website/hooks/compat-router";
import { InfoChips } from "@website/ui/info-chips";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import { SnappProDiscountChip } from "@website/website-ui/snapp-pro-discount-chip";
import { FC } from "react";
import { HotelCardPricingPropertiesType } from "./hotel-card-pricing.types";
import { calculateSnappProDisplayPricing } from "./hotel-card-pricing.utils";
export const HotelCardPricing: FC<HotelCardPricingPropertiesType> = properties => {
  const $ = _c(34);
  const router = useCompatRouter();
  const {
    date_from,
    date_to
  } = router.query;
  const {
    price,
    priceOff: t0,
    size: t1,
    discountPercentage,
    landing: t2,
    className,
    basePrice,
    basePriceOff,
    adjustments,
    snappProDiscountClassName
  } = properties;
  const priceOff = t0 === undefined ? 0 : t0;
  const size = t1 === undefined ? "responsive" : t1;
  const landing = t2 === undefined ? false : t2;
  let shouldShowSnappProDiscount;
  let snappProDiscountPercentage;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== adjustments || $[1] !== basePrice || $[2] !== basePriceOff || $[3] !== className || $[4] !== date_from || $[5] !== date_to || $[6] !== discountPercentage || $[7] !== landing || $[8] !== price || $[9] !== priceOff || $[10] !== router.locale || $[11] !== router.query.room_capacity || $[12] !== size) {
    const {
      price: displayPrice,
      priceOff: t8,
      snappProDiscountPercentage: t9
    } = calculateSnappProDisplayPricing({
      price,
      priceOff,
      adjustments
    });
    snappProDiscountPercentage = t9;
    const displayPriceOff = t8 === undefined ? 0 : t8;
    shouldShowSnappProDiscount = typeof snappProDiscountPercentage === "number" && snappProDiscountPercentage > 0;
    const hasDateAndPassengers = Boolean(date_from && date_to && router?.query?.room_capacity && Number(router?.query?.room_capacity) > 0);
    const isVilla = process.env.NEXT_PUBLIC_APP_NAME === "villa";
    let t10;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = ["website", "homepage"];
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    const isHomePage = t10.includes(process.env.NEXT_PUBLIC_APP_NAME as string);
    const shouldShowDiscount = displayPriceOff > 0 && displayPrice > displayPriceOff && (size !== "small" || size === "small" && isHomePage);
    const discountText = adjustments ? displayPercentageDiscount(displayPrice, displayPriceOff) : landing ? `%${numberConvert((Math.ceil(discountPercentage as number) * 100)?.toFixed(0), {
      locale: "fa"
    })}` : displayPercentageDiscount(price, displayPriceOff);
    const discountedPrice = displayPriceOff && displayPrice > displayPriceOff ? displayPriceOff : displayPrice;
    const effectivePrice = isVilla ? hasDateAndPassengers ? discountedPrice : basePriceOff ?? discountedPrice : discountedPrice;
    const villaOriginalPrice = hasDateAndPassengers ? displayPrice : basePrice;
    const villaDiscountedPrice = hasDateAndPassengers ? displayPriceOff : basePriceOff;
    const shouldShowVillaDiscount = isVilla && size === "small" && typeof villaOriginalPrice === "number" && typeof villaDiscountedPrice === "number" && villaOriginalPrice > villaDiscountedPrice;
    t5 = `${size === "small" ? "flex flex-col items-end justify-center" : `flex flex-col justify-end lg:justify-center ${size === "xSmall" ? "items-start gap-0" : "items-end lg:items-center"} `} `;
    t6 = shouldShowDiscount && !isVilla && <div className={`mb-1 flex items-center ${size === "xSmall" ? "gap-1" : "gap-2"}`}><span className={`text-on-surface-disable line-through ${size === "xSmall" ? "text-overline" : "text-body-2"}`}>{numberConvert(numberSeparator(displayPrice), {
          locale: router.locale || "fa"
        })}</span><InfoChips className="!w-[32px] justify-center !p-[2px]" size={size === "xSmall" ? "compact" : "medium"} text={discountText} variant="round-accent" /></div>;
    t7 = shouldShowVillaDiscount && <div className="flex w-full items-center justify-end gap-2"><span className="text-on-surface-disable text-body-2 line-through">{numberConvert(numberSeparator(villaOriginalPrice), {
          locale: router.locale || "fa"
        })}</span><InfoChips className="!w-[30px] justify-center !p-[2px]" size="medium" variant="round-accent" text={discountText} /></div>;
    t3 = `${className} ${size === "xSmall" ? "text-body-2 w-full font-bold" : size === "small" ? "text-on-surface-high-emphasis text-subtitle-1 font-bold" : "text-on-surface-high-emphasis text-headline-6 font-bold"}`;
    t4 = displayPrice ? size === "small" && basePrice && !isVilla ? <div className="flex flex-col items-end gap-1"><div>{numberConvert(numberSeparator(effectivePrice), {
          locale: router.locale || "fa"
        })}<span className="text-subtitle-2 px-1">تومان</span></div></div> : <>{numberConvert(numberSeparator(effectivePrice), {
        locale: router.locale || "fa"
      })}<span className={`px-1 ${size === "xSmall" ? "text-body-2" : "text-subtitle-2"}`}>تومان</span></> : <>ناموجود</>;
    $[0] = adjustments;
    $[1] = basePrice;
    $[2] = basePriceOff;
    $[3] = className;
    $[4] = date_from;
    $[5] = date_to;
    $[6] = discountPercentage;
    $[7] = landing;
    $[8] = price;
    $[9] = priceOff;
    $[10] = router.locale;
    $[11] = router.query.room_capacity;
    $[12] = size;
    $[13] = shouldShowSnappProDiscount;
    $[14] = snappProDiscountPercentage;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    shouldShowSnappProDiscount = $[13];
    snappProDiscountPercentage = $[14];
    t3 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
  }
  let t8;
  if ($[21] !== t3 || $[22] !== t4) {
    t8 = <span className={t3}>{t4}</span>;
    $[21] = t3;
    $[22] = t4;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== shouldShowSnappProDiscount || $[25] !== snappProDiscountClassName || $[26] !== snappProDiscountPercentage) {
    t9 = shouldShowSnappProDiscount && <div className={`mt-1 ${snappProDiscountClassName ?? ""}`}><SnappProDiscountChip percentage={snappProDiscountPercentage} /></div>;
    $[24] = shouldShowSnappProDiscount;
    $[25] = snappProDiscountClassName;
    $[26] = snappProDiscountPercentage;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t5 || $[29] !== t6 || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
    t10 = <div className={t5}>{t6}{t7}{t8}{t9}</div>;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  return t10;
};